import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetDeletedTransactionsByUserIdQuery } from '../services/ledger/ledgerApi';
import Loading from '../components/Loading';

function DeletedLendenPage() {
  const navigate = useNavigate();
  const { userId } = useParams();
  
  // Helper function to format date to DD-MM-YYYY with 12-hour time
  const formatDate = (dateString) => {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    
    hours = hours % 12;
    hours = hours ? hours : 12; // 0 should be 12
    const formattedHours = String(hours).padStart(2, '0');
    
    return `${day}-${month}-${year} ${formattedHours}:${minutes}:${seconds} ${ampm}`;
  };

  // Fetch deleted transactions data
  const { data: response, isLoading, error } = useGetDeletedTransactionsByUserIdQuery(userId);

  // Parse response data
  const transactionData = Array.isArray(response?.data) ? response.data : [];

  return (
    <div className="">
      <div className="bg-white rounded shadow">
        {/* Header */}
        <div className="bg-[#2c3e3e] text-white px-5 py-4 flex justify-between items-center">
          <h2 className="text-xl font-semibold">Deleted Lenden</h2>
          <button 
            onClick={() => navigate(-1)}
            className="bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600"
          >
            Back
          </button>
        </div>

        {/* Loading State */}
        {isLoading && (
          <div className="p-8 flex justify-center">
            <Loading />
          </div>
        )}

        {/* Error State */}
        {error && (
          <div className="p-8">
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
              Error loading deleted transactions
            </div>
          </div>
        )}

        {/* Table */}
        {!isLoading && !error && (
          <div className="overflow-x-auto px-5 py-5">
            <table className="ledger-table w-full border-collapse border border-gray-300">
              <thead className="bg-[#2c3e3e] text-white">
                <tr>
                  <th className="p-2 border border-gray-600 text-left whitespace-nowrap">Date</th>
                  {/* <th className="p-2 border border-gray-600 text-left whitespace-nowrap">Post Date</th> */}
                  {/* <th className="p-2 border border-gray-600 text-left whitespace-nowrap">Collection</th> */}
                  <th className="p-2 border border-gray-600 text-left whitespace-nowrap">Debit</th>
                  <th className="p-2 border border-gray-600 text-left whitespace-nowrap">Credit</th>
                  <th className="p-2 border border-gray-600 text-left whitespace-nowrap">Payment Type</th>
                  <th className="p-2 border border-gray-600 text-left whitespace-nowrap">Remark</th>
                  <th className="p-2 border border-gray-600 text-left whitespace-nowrap">Done By</th>
                  <th className="p-2 border border-gray-600 text-left whitespace-nowrap">Deleted By</th>
                </tr>
              </thead>
              <tbody>
                {transactionData.length === 0 ? (
                  <tr>
                    <td colSpan="9" className="p-4 text-center text-gray-500">
                      No deleted transactions found
                    </td>
                  </tr>
                ) : (
                  transactionData.map((item, index) => (
                    <tr key={index} className={`bg-white hover:bg-gray-50 ${/liya/i.test(item.paymentType||'') ? 'ledger-liya' : /diya/i.test(item.paymentType||'') ? 'ledger-diya' : ''}`}>
                      <td className="p-2 border border-gray-300 whitespace-nowrap">{formatDate(item.date)}</td>
                      {/* <td className="p-2 border border-gray-300 whitespace-nowrap">{formatDate(item.postDate)}</td> */}
                      {/* <td className="p-2 border border-gray-300 whitespace-nowrap">{item.collectionName}</td> */}
                      <td className="p-2 border border-gray-300 whitespace-nowrap">{item.debit || 0}</td>
                      <td className="p-2 border border-gray-300 whitespace-nowrap">{item.credit || 0}</td>
                      <td className="p-2 border border-gray-300 whitespace-nowrap">{item.paymentType}</td>
                      <td className="p-2 border border-gray-300 whitespace-nowrap">{item.remark}</td>
                      <td className="p-2 border border-gray-300 whitespace-nowrap">{item.doneBy}</td>
                      <td className="p-2 border border-gray-300 whitespace-nowrap">{item.deletedBy || ''}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default DeletedLendenPage;
